
import React from 'react';
import { useTranslation } from 'react-i18next';
import useDreamWeaveData from '../../hooks/useDreamWeaveData';
import LoadingSpinner from '../LoadingSpinner';

const LiveFeed = ({ dreamWeaveId, nexusId }) => {
    const { t } = useTranslation();
    const { quests, event, loading, error } = useDreamWeaveData(dreamWeaveId, nexusId);

    if (loading) {
        return <LoadingSpinner message={t('liveFeed.loading')} />;
    }

    if (error) {
        return <p className="text-red-500">{t('liveFeed.error')}</p>;
    }

    return (
        <div className="bg-gray-900/50 backdrop-blur-sm p-4 rounded-lg border border-cyan-500/20 flex-grow">
            <h2 className="text-xl font-bold text-cyan-300 mb-4 text-center">{t('liveFeed.title')}</h2>
            <ul>
                {event && (
                    <li className="text-sm mb-2 animate-pulse"><span className="text-purple-400 font-semibold">{t('liveFeed.eventPrefix')}</span> {event.description}</li>
                )}
                {quests.map(quest => (
                    <li key={quest.id} className="text-sm mb-2"><span className="text-yellow-400 font-semibold">{t('liveFeed.questPrefix')}</span> {quest.title}</li>
                ))}
                {/* Add more event types here as they become available in the data */}
            </ul>
        </div>
    );
};

export default LiveFeed;
